import React from 'react';
import './honorsimple.css';

function HonorSimple(props){
  if(props.honors.length>0){
    return(
      <div className='container0 center960 border'>
        <div className='m1topic'>企业荣誉</div>
        <div className='hsc'>
          {props.honors.map(function(item,index){
            return(
              <div className='hsitem hswidth' key={index}>
                <div className='hsimg'><img src={item.img} alt='img' /></div>
                <div className='hstopic'>{item.topic}</div>
              </div>
            );
          })
        }      
        </div>
      </div>
    )
  }else{
    return(
      <div className='hs'>
        <div className='hstopic'>伝业蝣誉</div>
        <div className='hstopic'>loading...</div>
      </div>
    )
  }
  
}
export default HonorSimple;